<div mat-dialog-title>
  <div class="title">
    <div>
      <p>{{ data.failed ? 'Falhas no envio de email(s)' : 'Email(s) enviado(s) com sucesso' }}</p>
      <small>
        @if (data.failed) {
          {{ getTotalBranches() }} unidades • {{ getTotalFailed() }} falhas
        } @else {
          {{ getTotalBranches() }} unidades • {{ getTotalSuccess() }} enviados
        }
      </small>
    </div>
    <mat-icon mat-dialog-close (click)="dialogRef.close()">close</mat-icon>
  </div>
</div>
<mat-dialog-content>
  <table>
    <thead>
      <tr>
        <td class="first">CR Unidade</td>
        <td>Data | Hora</td>
        <td>E-mail(s)</td>
        <td>Motivo</td>
        <td class="last">Ação</td>
      </tr>
    </thead>
    <tbody>
      @for (group of listGrid; track group.branchCode) {
        @if ((data.failed && group.failedList.length > 0) || (!data.failed && group.sentSuccessfullyList.length > 0)) {
          <tr>
            <td>{{ group.branchCode }}</td>
            <td>{{ group.sendDate | date : "dd/MM/yyyy H:mm:ss" }}</td>
            <td>
              <div class="emails">
                @if (data.failed) {
                  @for (recipient of group.failedList; track recipient.id) {
                    <p class="fail">{{ recipient.email }}</p>
                  }
                } @else {
                  @for (recipient of group.sentSuccessfullyList; track recipient.id) {
                    <p class="success">{{ recipient.email }}</p>
                  }
                }
              </div>
            </td>
            <td>
              @if (data.failed) {
                <div class="reasons">
                  @for (recipient of group.failedList; track recipient.id) {
                    <p class="fail">{{ recipient.failureReason }}</p>
                  }
                </div>
              } @else {
                <p class="send">-</p>
              }
            <td>
              @if (data.failed && group.failedList.length > 0) {
                <button class="btn danger" (click)="dialogRef.close(data.log.id)">
                  Reenviar
                </button>
              } @else if (!data.failed && group.sentSuccessfullyList.length > 0) {
                <p class="send">Enviado</p>
              }
            </td>
          </tr>
        }
      }
      @if (!listGrid.length || (data.failed && getTotalFailed() === 0) || (!data.failed && getTotalSuccess() === 0)) {
        <tr>
          <td colspan="4">
            {{ data.failed ? 'Nenhuma falha encontrada' : 'Nenhum e-mail enviado' }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</mat-dialog-content>
